import React, { Component } from 'react';
import { DropdownButton, MenuItem} from 'react-bootstrap';
import './FilterButton.css';

class FilterButton extends Component {
  constructor(props) {
    super(props);
    // TODO: Add a new key/value pair in the state to keep track of type
    this.state = {
      title: this.props.filter.title
    };
  }

  changeOption = (option, action) => {
    return () => {
      this.setState({
        title: option.name
      });
      action();
    }
  }

  renderOptions() {
    return this.props.filter.options.map(option => {
      return <MenuItem key={option.key} eventKey={option.key} onSelect={this.changeOption(option, this.props.action(this.props.filter.key, option))}>{option.name}</MenuItem>
    });
  }

  render() {
    return (
      <DropdownButton id={this.props.filter.title.replace(/\s/g,'')} title={this.state.title}>
        {this.renderOptions()}
      </DropdownButton>
    );
  }
}

export default FilterButton;


// WEBPACK FOOTER //
// ./src/FilterButton.jsx